<template>
  <div>
    <Header
      class="yh-header"
      active="/product/place"
    />
    <div style="height: 70px" />
    <el-container class="container">
      <el-footer
        height="auto"
        class="footer"
      >
        <div class="block-panel">
          <div class="title">
            农产品属地化地质图
            <div class="split" />
            <div class="link">
              <span> 使用指引</span>
              <viewer
                :images="imgs"
                class="el-image"
              >
                <img
                  v-for="src in imgs"
                  :key="src"
                  :src="src"
                  :data-source="bigImgs"
                >
              </viewer>
            </div>
          </div>
        </div>
        <div class="map-and-ranking">
          <PageMap
            ref="map"
            :province-info="provinceInfo"
          />
          <PageForm @submitForm="submitForm" />
          <PageTable
            :loading.sync="loading"
            @onCurrentChange="onCurrentChange"
          />
        </div>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
import Header from '@/components/Header'
import PageForm from './Components/PageForm.vue'
import PageMap from './Components/PageMap.vue'
import PageTable from './Components/PageTable.vue'
import imgs from '@/assets/zy.png'
export default {
  name: 'ProductPlace',
  components: {
    Header,
    PageForm,
    PageMap,
    PageTable
  },
  data() {
    return {
      imgs: [imgs],
      bigImgs: '/images/cd-zy.png',
      loading: false,
      searchParams: {}, // 查询条件
      provinceInfo: [], // 选中的省份
      categoryCode: '',
      productValue: this.util.getVariantSession('tagId')
    }
  },
  created() {
  },
  methods: {
    /**
             * 获取表格数据
             * @author Ren YuLei 2020/11/9
             */
    getData(pageNum = 1) {
      const { searchParams } = this
      const province = this.splitGetCode(searchParams.province)
      this.loading = true
      this.$store.dispatch('productBasePage', {
        packageName: 'product',
        className: 'freshOriginInfo',
        methodName: 'retrieve',
        params: {
          ...searchParams,
          pageNum,
          numPerPage: 10,
          province: province === '00' ? '' : province,
          onSaleBegin: searchParams.date && searchParams.date[0].getMonth() + 1,
          onSaleEnd: searchParams.date && searchParams.date[1].getMonth() + 1
        }
      })
    },
    /**
             * 获取有数据的省份
             * @author Ren YuLei 2020/11/11
             */
    getCount() {
      const { searchParams } = this
      this.loading = true
      this.$store.dispatch('productBasePage', {
        packageName: 'product',
        className: 'freshOriginInfo',
        methodName: 'count',
        params: {
          ...searchParams,
          groupBy: 'province',
          province: undefined,
          onSaleBegin: searchParams.date && searchParams.date[0].getMonth() + 1,
          onSaleEnd: searchParams.date && searchParams.date[1].getMonth() + 1
        }
      })
    },
    /**
             * 查询
             * @author Ren YuLei 2020/11/11
             */
    submitForm(data) {
      this.provinceInfo = this.splitGetName(data.province)
      this.searchParams = data
      this.getData(1)
      this.getCount()
    },
    /**
             * 分页
             * @author Ren YuLei 2020/11/11
             */
    onCurrentChange(page) {
      this.getData(page)
    },
    splitGetName(arg) {
      if (!arg || !arg.length) return []
      let name = arg.map(item => {
        let i = item.indexOf(' ')
        return i > -1 ? item.substring(i + 1) : item.substring(0)
      })
      return name
    },
    /**
             *code中分离出code
             * @param  arg
             * @returns
             */
    splitGetCode(arg) {
      if (!arg || !arg.length) return ''
      let name = arg.map(item => {
        let i = item.indexOf(' ')
        return i > -1 ? item.substring(0, i) : ''
      })
      return name.join(',')
    }
  }
}
</script>

<style lang="less">
    .footer {
        background: #f7faf8;
        .block-panel {
            width: 1100px;
            margin: 0 auto;
            background: white;
            margin-top: 20px;
        }
        .map-and-ranking {
            width: 1100px;
            margin: 0 auto;
            background: white;
            margin-top: 20px;
        }
        .title {
            font-size: 32px;
            color: #333;
            font-weight: 600;
            padding: 25px 40px;
            line-height: 42px;
            display: flex;
            align-items: center;
            .split {
                width: 1px;
                height: 16px;
                background: #ccc;
                display: inline-block;
                margin: 0 15px;
            }
            .link {
                display: flex;
                align-items: center;
                font-size: 18px;
                font-weight: 400;
                color: rgba(64, 177, 93, 1);
                line-height: 25px;
                cursor: pointer;
                .el-image{
                    width: 100px;
                    margin-left: -70px;
                    img{
                        width: 20px;
                        height: 16px;
                        padding-left: 70px;
                        display: block;
                    }

                }
            }
        }

    }
</style>
